"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _core2 = require("@stt-componentes/core");
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _icons = require("@stt-componentes/icons");
var _SttFavoritar = _interopRequireDefault(require("../SttFavoritar"));
var _SttSeeButton = _interopRequireDefault(require("../SttButton/SttSeeButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    card: {
      borderRadius: "16px",
      overflow: "hidden",
      backgroundColor: theme.palette.background["default"],
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      display: "flex",
      flexDirection: "column",
      height: "100%"
    },
    bannerWrapper: {
      position: "relative",
      width: "100%",
      paddingTop: "56.25%",
      backgroundColor: theme.palette.background["default"],
      overflow: "hidden",
      cursor: "pointer",
      transition: "opacity 0.2s ease-in-out",
      "&:hover": {
        opacity: 0.9
      }
    },
    bannerContent: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    bannerImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    },
    bannerOverlay: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      background: "linear-gradient(to top, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 100%)",
      padding: theme.spacing(2),
      color: theme.palette.background["default"],
      fontSize: "13px",
      fontWeight: 700,
      opacity: 0,
      transform: "translateY(20px)",
      transition: "opacity 0.6s, transform 0.6s cubic-bezier(0.4,0,0.2,1)",
      pointerEvents: "none"
    },
    bannerOverlayVisible: {
      opacity: 1,
      transform: "translateY(0)",
      pointerEvents: "auto"
    },
    cardBody: {
      padding: theme.spacing(2),
      display: "flex",
      flexDirection: "column"
    },
    titleText: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
      cursor: "default"
    },
    cardFooter: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    textoData: {
      fontSize: "12px",
      color: theme.palette.text.secondary
    },
    seeButton: {
      padding: theme.spacing(0.5),
      color: theme.palette.externo.main
    }
  };
});
var SttCard = function SttCard(props) {
  var id = props.id,
    titulo = props.titulo,
    turma = props.turma,
    conteudo_arquivo = props.conteudo_arquivo,
    dataInicio = props.dataInicio,
    dataFim = props.dataFim,
    instituicao = props.instituicao,
    visualizar = props.visualizar,
    situacaoCurso = props.situacaoCurso,
    tenho_interesse = props.tenho_interesse,
    onFavoritar = props.onFavoritar,
    index = props.index,
    acessar = props.acessar,
    naoComplementados = props.naoComplementados,
    situacaoInscricao = props.situacaoInscricao;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    mostrarBanner = _useState2[0],
    setMostrarBanner = _useState2[1];
  var dataInicioFormatada = dataInicio ? (0, _moment["default"])(dataInicio).format("DD/MM/YYYY") : "";
  var dataFimFormatada = dataFim ? (0, _moment["default"])(dataFim).format("DD/MM/YYYY") : "";
  return /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.card
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.bannerWrapper,
    onMouseEnter: function onMouseEnter() {
      return setMostrarBanner(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setMostrarBanner(false);
    },
    onClick: acessar
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.bannerContent
  }, conteudo_arquivo !== null && conteudo_arquivo !== void 0 && conteudo_arquivo.bannerCurso ? /*#__PURE__*/_react["default"].createElement("img", {
    src: conteudo_arquivo.bannerCurso,
    alt: titulo,
    className: classes.bannerImage
  }) : /*#__PURE__*/_react["default"].createElement(_icons.SttTeleeducacaoIcon, null)), instituicao && /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: "".concat(classes.bannerOverlay, " ").concat(mostrarBanner ? classes.bannerOverlayVisible : "")
  }, instituicao)), /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.cardBody
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, null, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: titulo,
    placement: "top",
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.titleText
  }, titulo))), /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.cardFooter
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: classes.textoData
  }, dataInicioFormatada, " ", dataFimFormatada ? "- ".concat(dataFimFormatada) : ""), /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.menuButton
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    style: {
      display: "flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/_react["default"].createElement(_SttFavoritar["default"], {
    situacaoCurso: situacaoCurso,
    tenho_interesse: tenho_interesse,
    naoComplementados: naoComplementados,
    situacaoInscricao: situacaoInscricao,
    onClick: function onClick() {
      return onFavoritar && onFavoritar(id, !tenho_interesse);
    }
  }), /*#__PURE__*/_react["default"].createElement(_SttSeeButton["default"], {
    className: classes.seeButton,
    id: index,
    onClick: function onClick(e) {
      e.stopPropagation();
      visualizar(id, titulo, turma);
    }
  }))))));
};
var _default = SttCard;
exports["default"] = _default;